// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3c_ZS","rootCenter":"LoadMoreObserver_rootCenter__3Zbmo","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1bCog"};